import { Injectable } from '@angular/core';
import { AttachmentService } from './attachment.service';
import { Observable, of } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ThumbnailCacheService {
  private cache = new Map<string, string>();

  constructor(private attachmentService: AttachmentService) {}

  getThumbnailUrl(attachmentId: string): Observable<string | null> {
    const cached = this.cache.get(attachmentId);
    if (cached) {
      return of(cached);
    }

    return this.attachmentService.downloadThumbnail({ attachmentId }).pipe(
      map(response => {
        if (response.body) {
          const url = URL.createObjectURL(response.body);
          this.cache.set(attachmentId, url);
          return url;
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }

  has(attachmentId: string): boolean {
    return this.cache.has(attachmentId);
  }

  getUrl(attachmentId: string): string | undefined {
    return this.cache.get(attachmentId);
  }

  removeByIds(ids: string[]) {
    for (const id of ids) {
      const url = this.cache.get(id);
      if (url) {
        URL.revokeObjectURL(url);
        this.cache.delete(id);
      }
    }
  }

  syncToAttachments(currentIds: Set<string>) {
    const staleIds = [...this.cache.keys()].filter(id => !currentIds.has(id));
    this.removeByIds(staleIds);
  }
}
